import { useEffect, useState } from "react";

type PermissionDetail = {
  url?: string;
  method?: string;
  response?: any;
};

export default function usePermissionBanner(matchPath: string) {
  const [detail, setDetail] = useState<PermissionDetail | null>(null);

  useEffect(() => {
    const handler = (e: Event) => {
      try {
        const d = (e as CustomEvent).detail as PermissionDetail;
        if (!d) return;
        if ((d as PermissionDetail & { suppressGlobalNotice?: boolean }).suppressGlobalNotice) {
          return;
        }
        if (typeof d.url === "string" && d.url.includes(matchPath)) {
          setDetail(d);
        }
      } catch {
        // ignore
      }
    };

    window.addEventListener(
      "app:permission-required",
      handler as EventListener,
    );
    return () => {
      window.removeEventListener(
        "app:permission-required",
        handler as EventListener,
      );
    };
  }, [matchPath]);

  return {
    detail,
    clear: () => setDetail(null),
  } as const;
}
